import type { Locale } from '../auth/types';

export function resolveLocale(
  userPreferred: Locale | null | undefined,
  workspaceDefault: Locale | null | undefined,
  browser: Locale
): Locale {
  if (userPreferred === 'ko' || userPreferred === 'ja') {
    return userPreferred;
  }

  if (workspaceDefault === 'ko' || workspaceDefault === 'ja') {
    return workspaceDefault;
  }

  if (browser === 'ko' || browser === 'ja') {
    return browser;
  }

  return 'ko';
}
